const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'chart-tooltip';
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context) => {
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  if (tooltip.opacity === 0 || !chart.options.tooltips.enabled) {
    tooltipEl.style.opacity = 0;
    return;
  }

  const contents = tooltipEl;
  const helpers = chart.config.options?.helpers;
  const content = document.createElement('div');

  while (contents.firstChild) {
    contents.firstChild.remove();
  }

  if (tooltip.body) {
    const title = tooltip.title || [];
    const lines = tooltip.body.map((b) => b.lines);

    if (title.length) {
      let header = document.createElement('div');
      header.className = 'header';

      if (helpers?.tooltipHeaderFormatter) {
        const result = helpers.tooltipHeaderFormatter(title);

        if (result) {
          header.innerHTML = result;
        }
      } else {
        title.forEach((title) => {
          const div = document.createElement('div');
          const text = document.createTextNode(title);

          div.appendChild(text);
          header.appendChild(div);
        });
      }

      contents.appendChild(header);
    }

    if (helpers?.tooltipContentFormatter) {
      if (!helpers.tooltipContentFormatter(content, lines, tooltip)) {
        content.innerhHTML = '';
        tooltipEl.style.opacity = 0;
        return;
      }
    } else {
      lines.forEach((body, i) => {
        if (body.length === 0) {
          return;
        }

        const colors = tooltip.labelColors[i];
        const point = document.createElement('div');

        point.className = 'point';
        point.style.background =
          typeof colors.backgroundColor === 'string' ? colors.backgroundColor : colors.borderColor;

        if (colors.borderColor) {
          point.style.border = `1px solid ${colors.borderColor}`;
        }

        const item = document.createElement('div');
        item.className = 'item';

        const metric = document.createElement('div');
        const value = document.createElement('div');
        const [m, v] = body[0].split(': ');

        metric.className = 'metric';

        if (helpers?.tooltipMetricFormatter) {
          metric.innerHTML = helpers.tooltipMetricFormatter(m);
        } else {
          metric.innerHTML = m;
        }

        value.className = 'value';

        if (helpers?.tooltipValueFormatter) {
          value.innerHTML = helpers.tooltipValueFormatter(v);
        } else {
          value.innerHTML = v;
        }

        const pair = document.createElement('div');

        pair.className = 'pair';
        pair.appendChild(metric);
        pair.appendChild(value);

        item.appendChild(point);
        item.appendChild(pair);

        content.appendChild(item);
      });
    }

    contents.appendChild(content);
  }

  const isInViewport = () => {
    const rect = tooltipEl.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
  };

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
  const tooltipRect = tooltipEl.getBoundingClientRect();
  const verticalAdjustment = tooltipRect.height > chart.canvas.height ? tooltipRect.height - chart.canvas.height : 0;

  tooltipEl.style.left = positionX + tooltip.caretX + 24 + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY - verticalAdjustment + 'px';

  setTimeout(() => {
    const inView = isInViewport();

    if (!inView) {
      tooltipEl.style.left = positionX + tooltip.caretX - tooltipRect.width + 'px';
      tooltipEl.style.top = positionY + tooltip.caretY - tooltipRect.height / 2 + 24 + 'px';
    }

    tooltipEl.style.opacity = 1;
  }, 0);
};
